<template>
    <div>
        <my-table :data="formData.listPfd">
            <el-table-column label="评分点名称" prop="nodecaption"></el-table-column>
            <el-table-column label="描述" prop="standard"></el-table-column>
            <el-table-column label="打分区间" v-if="formData.titlebj">
                <template slot-scope="scope">
                    {{scope.row.lowerlimit}}--{{scope.row.upperlimit}}
                </template>
            </el-table-column>
            <el-table-column label="固定分值" v-if="formData.titlebj">
                <template slot-scope="scope">
                    {{scope.row.backup2}}
                </template>
            </el-table-column>
            <el-table-column 
                label="固定打分原因是否必填" 
                v-if="formData.titlebj&&formData.filecontenttype!='1'">
                <template slot-scope="scope">
                    <span v-if="scope.row.reasonrequire=='true'">是</span>
                    <span v-if="scope.row.reasonrequire=='false'">否</span>
                    <span v-if="scope.row.reasonrequire==null">{{scope.row.reasonrequire}}</span>
                </template>
            </el-table-column>
            <!--
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <my-btn 
                        type="edit" 
                        @click="NodeDetailEdit(scope.row.nodekey,formData.bdcode)">
                        修改
                    </my-btn>
                </template>
            </el-table-column>
            -->
        </my-table>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return{
            formData:{}
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        NodeDetailEdit(nodekey,bdcode){
            var that = this
            $.post(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.data.type+`/nodedetail/isedit.json`, {
                nodeid:nodekey,
                bdcode:bdcode
            }, data => {
                if(data.result){
                    that.goto({
                        path: './nodedetailEdit',
                        query: {
                            bdcode:bdcode,
                            nodeid:nodekey,
                            filecontenttype:that.formData.filecontenttype,
                            type:that.data.type
                        }
                    });
                }else{
                    ShowMsg(data.msg,'warning')
                }
            });
        }
    },
    created() {
        var that=this;
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.data.type+`/pfnodedetail.json`,that.data,(data, res) => {
            that.formData = data
        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
